module.exports = __webpack_public_path__ + "img/Warrior-tauren-f-70.c605520f.gif";